module.exports = __webpack_public_path__ + "static/img/vip_img.dceea79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip_img.png
// module id = xw88
// module chunks = 1